import lozad from 'lozad';
import AOS from 'aos';
import Headroom from 'headroom.js';

export default {
    init() {

        // PRELOADER
        $(window).on('load', function () {
            $('.loader').fadeOut();
            $('.loader-mask')
                .delay(350)
                .fadeOut('slow');
        });

        //  FANCYBOX
        (function () {
            $('[data-fancybox="gallery"]').fancybox();
            $('[data-fancybox="showcase-gallery"]').fancybox();
        })();

        // MASONRY
        (function (){
            var $grid = $('.posts-grid.posts-grid_masonry');
            
            $grid.isotope();
        })();

        // POST GRID
        (function () {
            const $container = $('#jsBlogEntries');
            const $entries = $container.find('.js-entry'); 
            
            $(window).on('load', function() {
            
                $entries.each(function () {
                    const $this = $(this);
                    const $entry_content = $this.find('.entry-content');
                    const $reveal_on_hover = $this.find('.reveal-on-hover');
                                        
                    const rohAutoHeight = $reveal_on_hover.height();
                    $reveal_on_hover.css({height: 0, opacity: 0});

                    const curHeight = $entry_content.height();                     
                    const autoHeight = $entry_content.css('height', 'auto').height();                    
                    

                    var toshow = true;
                    var tofade = false;

                    $this.on('mouseenter', function(){
                        if(toshow) {
                            toshow = false;

                            $entry_content.height(autoHeight).animate({height: curHeight}, 500, function() {
                                $reveal_on_hover.animate({height: rohAutoHeight, opacity: 1}, 500, function(){
                                    tofade = true;
                                });
                            });
                        }
                    })

                    $this.on('mouseleave', function(){
                        if(tofade) {
                            tofade = false;
                        
                            $reveal_on_hover.animate({height: 0, opacity: 0}, 500, function(){
                                $entry_content.height(curHeight).animate({height: autoHeight}, 500, function(){
                                    toshow = true;
                                });
                            });
                        }
                    });
                });

            });

        })();

        // WEBINAR POPUP
        // (function() {

        //     function setCookie(cname,cvalue,exdays) {
        //         const d = new Date();
        //         d.setTime(d.getTime() + (exdays*24*60*60*1000));
        //         let expires = 'expires=' + d.toGMTString();
        //         document.cookie = cname + '=' + cvalue + ';' + expires + ';path=/';
        //     }

        //     function getCookie(cname) {
        //         let name = cname + '=';
        //         let decodedCookie = decodeURIComponent(document.cookie);
        //         let ca = decodedCookie.split(';');
        //         for(let i = 0; i < ca.length; i++) {
        //             let c = ca[i];
        //             while (c.charAt(0) == ' ') {
        //             c = c.substring(1);
        //             }
        //             if (c.indexOf(name) == 0) {
        //             return c.substring(name.length, c.length);
        //             }
        //         }
        //         return '';
        //     }

        //     const exit = e => {
        //         const shouldExit =
        //             [...e.target.classList].includes('exit-intent-popup') || // user clicks on mask
        //             e.target.className === 'close' || // user clicks on the close icon
        //             e.keyCode === 27; // user hits escape
            
        //         if (shouldExit) {
        //             // document.querySelector('.webinar-modal').classList.remove('visible');
        //             $('.webinar-modal').modal('hide');
        //         }
        //     };
            
        //     const mouseEvent = e => {
        //         const shouldShowExitIntent = 
        //             !e.toElement && 
        //             !e.relatedTarget &&
        //             e.clientY < 10;
            
        //         if (shouldShowExitIntent) {
        //             document.removeEventListener('mouseout', mouseEvent);
        //             // document.querySelector('.webinar-modal').classList.add('visible');
        //             $('.webinar-modal').modal('show');
            
        //             setCookie('exitIntentShown', true, 30);
        //         }
        //     };
            
        //     if (!getCookie('exitIntentShown')) {
        //         setTimeout(() => {
        //             document.addEventListener('mouseout', mouseEvent);
        //             document.addEventListener('keydown', exit);
        //             document.querySelector('.webinar-modal').addEventListener('click', exit);
        //         }, 0);
        //     }
        // })();

        // EXIT MAT POPUP
        (function() {

            let attempt = 0;

            function setCookie(cname,cvalue,exdays) {
                const d = new Date();
                d.setTime(d.getTime() + (exdays*24*60*60*1000));
                let expires = 'expires=' + d.toGMTString();
                document.cookie = cname + '=' + cvalue + ';' + expires + ';path=/';
            }

            function getCookie(cname) {
                let name = cname + '=';
                let decodedCookie = decodeURIComponent(document.cookie);
                let ca = decodedCookie.split(';');
                for(let i = 0; i < ca.length; i++) {
                    let c = ca[i];
                    while (c.charAt(0) == ' ') {
                    c = c.substring(1);
                    }
                    if (c.indexOf(name) == 0) {
                    return c.substring(name.length, c.length);
                    }
                }
                return '';
            }

            
            const mouseEvent = () => {
                if(document.querySelector('.exit-mat-popup') && attempt < 1) {
                    document.querySelector('.exit-mat-popup').classList.add('show');
                    document.removeEventListener('mouseout', mouseEvent);
                    setCookie('exitIntentShown', true, 30);                    
                }
            };

            const exit = e => {
                const shouldExit = e.target.className === 'close-span';

                if (shouldExit) {
                    document.querySelector('.exit-mat-popup').classList.remove('show');                    
                    attempt++;
                    console.log(attempt);
                }
            };
            
            if (!getCookie('exitIntentShown')) {
                setTimeout(() => {
                    document.addEventListener('mouseleave', mouseEvent);
                    document.addEventListener('click', exit);                    
                }, 0); 
            }
        })();

        (function(){
            // INIT AOS
            $(window).on('load', function () {
                AOS.init({
                    easing: 'ease-in-out',
                    duration: 1000,
                });
            });

            $(window).on('resize load', function () {
                setTimeout(function () {
                    AOS.refresh();
                    $('.slick-slider').slick('setPosition');
                }, 300);
            }).resize();
        })();

        // SUBSCRIPTION FORM MODAL
        (function(){

            $('#formContent .form-content').detach().appendTo('#formModalContainer');

            const modal = e =>{
                const triggerModal = e.target.classList.contains('btn-modal-trigger');

                if (triggerModal) {                    
                    $('#subscriptionModalCenter').modal();
                }
            }

            setTimeout(() => {
                document.addEventListener('click', modal);
            });
        })();

        // SUBSCRIPTION FORM MODAL ANCHOR
        (function(){
            // Function to open the Bootstrap modal
            function openModal() {
                $('#subscriptionModalCenter').modal('show');
            }

            // Check if the URL contains the specific anchor link
            $(document).ready(function () {
                if (window.location.href.indexOf('#contactUs') > -1) {
                openModal();
                }
            });
        })();


        // HEADER STYLE
        // (function () {
        //     $(window).on('load scroll', function () {
        //         if ($('#sectionHero').length) {
        //             var el1_visible = false;
        //             var top_of_element1 = $('#sectionHero').offset().top;
        //             var bottom_of_element1 = $('#sectionHero').offset().top + $('#sectionHero').outerHeight();
        //         }
        //         if ($('#methodology').length) {
        //             var el2_visible = false;
        //             var top_of_element2 = $('#methodology').offset().top;
        //             var bottom_of_element2 = $('#methodology').offset().top + $('#methodology').outerHeight();
        //         }
        //         if ($('#phaseEnd').length) {
        //             var el3_visible = false;
        //             var top_of_element3 = $('#phaseEnd').offset().top;
        //             var bottom_of_element3 = $('#phaseEnd').offset().top + $('#phaseEnd').outerHeight();
        //         }

        //         var bottom_of_screen = $(window).scrollTop() + $(window).innerHeight();
        //         var top_of_screen = $(window).scrollTop() + 100;

        //         if ((bottom_of_screen > top_of_element1) && (top_of_screen < bottom_of_element1)) {
        //             el1_visible = true;
        //         }
        //         if ((top_of_screen > top_of_element2) && (top_of_screen < bottom_of_element2)) {
        //             el2_visible = true;
        //         }
        //         if ((top_of_screen > top_of_element3) && (top_of_screen < bottom_of_element3)) {
        //             el3_visible = true;
        //         }

        //         if (el1_visible || el2_visible || el3_visible) {
        //             $('#siteHeader').addClass('header-light');
        //         } else {
        //             // the element is not visible, do something else
        //             $('#siteHeader').removeClass('header-light');
        //         }

        //     });
        // })();

        // DETECT MOUSE LOCATION
        (function () {
            $('#jsQuestionSlider').on('mousemove', function (e) {
                if ((e.pageX - this.offsetLeft) < $(this).width() / 2) {
                    $(this).addClass('mouse-left');
                    $(this).removeClass('mouse-right');
                } else {
                    $(this).addClass('mouse-right');
                    $(this).removeClass('mouse-left');
                }
            });
        })();

        // PRELOADER
        (function () {
            $('html').removeClass('no-js');
            $('body').stop().animate({ 'opacity': '1' }, 1000);
        })();

        // INIT LOZAD
        (function () {
            const observer = lozad(); // lazy loads elements with default selector as '.lozad'
            observer.observe();
        })();

        // HEADROOM
        (function () {
            var myElement = document.querySelector('.headroom');
            if (myElement) {
                var headroom = new Headroom(myElement);
                headroom.init();
            }
        })();

        // KEYBOARD SCROLLING IN PANELS
        // SmoothScroll tracks focus from mouse clicks only, so for a keyboard
        // user it scrolls the page and cancels the key, even when a scrolling
        // panel has focus. Scroll keys on a focused panel that can scroll stop
        // here, before SmoothScroll's window listener, and the browser scrolls
        // the panel itself.
        (function () {
            var keys = ['ArrowUp', 'ArrowDown', 'PageUp', 'PageDown', 'Home', 'End', ' ', 'Spacebar'];
            var scrolls = function (el) {
                var overflow = window.getComputedStyle(el).overflowY;
                return (overflow === 'auto' || overflow === 'scroll') && el.scrollHeight > el.clientHeight + 1;
            };

            document.addEventListener('keydown', function (e) {
                var el = e.target;
                if (keys.indexOf(e.key) === -1 || !el || el.nodeType !== 1 || el === document.body) return;
                if (scrolls(el)) e.stopPropagation();
            });
        })();

        // NAV COLLAPSE
        (function () {
            const $nav = $('#primaryNavigation');
            const $nav_links = $nav.find('.menu-item a');

            $nav_links.on('click', function () {
                $nav.collapse('hide');
            });

            $(window).on('scroll', function () {
                $nav.collapse('hide');
            });

            $(document).mouseup(function () {
                if ($nav.hasClass('show')) {
                    $nav.collapse('hide');
                }
            });
        })();

        // PARALLAX
        // (function () {
        //     $('.parallax-window').parallax({
        //         naturalWidth: 1445,
        //         naturalHeight: 548,
        //         bleed: 10,
        //         speed: .8,
        //     });
        // })();


        // TOGGLE FORM
        (function () {
            $('.js-toggle-form').on('click', function () {
                $('#letstalkSectionForm').collapse('show');
            });
        })();

        // LETS TALK MODAL
        (function () {
            function triggerModal() {
                console.log(window.location.hash);
                $('#subscriptionModalCenter').modal('show');
            }

            if(window.location.hash) {
                if(window.location.hash === '#letstalk') {
                    triggerModal();
                }
            }

            $('a[href*="#letsTalk"]').click(function(e){
                e.preventDefault();
                triggerModal();
            });
        })();

        // AJAX POSTS LOAD
        (function() {
            const $postsContainer = $('#jsAjaxPosts');
            const $postsGrid = $('#jsAjaxPostsGrid');
            const $loadPostsBtn = $('#jsAjaxCta');
            let btnText = $loadPostsBtn.text();
            let queryVars = $loadPostsBtn.data('query-vars');
            let postsPerPage;
            let offset;

            if (queryVars) {
                postsPerPage = queryVars.posts_per_page;
                offset = queryVars.offset;
            }
            let totalCount = $loadPostsBtn.data('total');

            function appendData(dataArray) {
                for (var i = 0; i < dataArray.length; i++) {
                    var markup = dataArray[i];
                    // Convert HTML string into DOM object of new document
                    var postDocument = new DOMParser().parseFromString(
                        markup,
                        'text/html'
                    );
                    // Get the post DOM object
                    var post = postDocument.body.firstChild;
                    var animationDelay = 0.3 * i;

                    post.style.animationDelay = animationDelay + 's';
                    $postsGrid.append(post);
                }
            }

            function noMorePosts() {
                // This function runs after we've loaded the final post.
                $loadPostsBtn.remove();
            }

            $loadPostsBtn.click(function(event){
                event.target.innerHTML = 'LOADING...';

                $.ajax({
                    url: ajax_obj.ajax_url, // eslint-disable-line
                    type: 'post',
                    data: {
                        action: 'ajax_load_posts',
                        security: ajax_obj.ajax_nonce, // eslint-disable-line
                        queryVars: queryVars,
                    },
                    beforeSend: function () {
                        $postsContainer.attr('data-loading', 'true');
                    },
                    complete: function () {
                        $postsContainer.attr('data-loading', 'false');
                    },
                    success: function (jsonData) {                    
                        event.target.innerHTML = btnText;

                        var data = JSON.parse(jsonData);
                        // console.log(data);                        

                        if (offset + postsPerPage >= totalCount) {
                            appendData(data.posts);
                            noMorePosts();
                        } else {
                            appendData(data.posts);
                        }

                        // Increment the offset
                        offset += postsPerPage;
                        queryVars.offset = offset;
                    },
                    error: function (MLHttpRequest, textStatus, errorThrown) {
                        alert(errorThrown);
                    },
                });
            });


        })();


        // SMOOTH HASH SCROLL 
        (function () {
            // Select all links with hashes
            $('a[href*="#"]')
                // Remove links that don't actually link to anything
                .not('[href="#"]')
                .not('[href="#0"]')
                .not('[href="#letsTalk"]')
                .click(function (event) {
                    // On-page links
                    if (location.pathname.replace(/^\//, '') === this.pathname.replace(/^\//, '') && location.hostname === this.hostname) {
                        // Figure out element to scroll to
                        var target = $(this.hash);
                        target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
                        // Does a scroll target exist?
                        if (target.length) {
                            // Only prevent default if animation is actually gonna happen
                            event.preventDefault();
                            $('html, body').animate({
                                scrollTop: target.offset().top,
                            }, 1500, function () {
                                // Callback after animation
                                // Must change focus!
                                var $target = $(target);
                                $target.focus();
                                if ($target.is(':focus')) { // Checking if the target was focused
                                    return false;
                                } else {
                                    $target.attr('tabindex', '-1').css('outline', '0'); // Adding tabindex for elements not focusable
                                    $target.focus(); // Set focus again
                                }
                            });
                        }
                    }
                });
        })();

    },
    finalize() {
        // JavaScript to be fired on all pages, after page specific JS is fired
    },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js